<template>
  <div class="login-box">
    <header class="header">
      乐 康 护 理 服 务 管 理 系 统
    </header>
    <div class="flexbox justify-content-center mt180">
      <div>
        <div class="left">

          <img src="../assets/web-1.png" alt="login">
        </div>
        <!-- <ul class="flexbox text">
          <li>为政府分忧</li>
          <li>为患者解难</li>
          <li>为家庭减负</li>
        </ul> -->
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
        <h3 class="title">系 统 登 录</h3>
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            autocomplete="off"
            placeholder="账 号: "
            prefix-icon="el-icon-goods">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input :type="textType"
            v-model="loginForm.password"
            @keyup.native.enter="login('loginForm')"
            autocomplete="off"
            placeholder="密 码: "
            prefix-icon="el-icon-time">
            <i slot="suffix" class="el-input__icon el-icon-view btn-eye" @click="changeType"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login('loginForm')" class="login-btn" v-loading="loading">登 录</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="copyright">
      Copyright © 2023-2024 潜山乐康护理站有限公司 乐康护理 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">皖ICP备2023004948号-1</a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34082402000495" target="_blank"><img src="~@/assets/e232b8d8533a6a89221604567a1fffb.png"/> 皖公网安备 34082402000495号</a>
    </div>
  </div>
</template>

<script>
import { login } from '@/api'
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: ' ', trigger: 'blur' }],
        password: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      loading: false,
      showMsg: false,
      textType: 'password'
    }
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          login(this.loginForm)
            .then(res => {
              if (res.status) {
                sessionStorage.setItem('AuthToken', res.data.token)
                sessionStorage.setItem('auth', res.data.auth)
                sessionStorage.setItem('is_finance', res.data.is_finance)
                sessionStorage.setItem('is_hospital', res.data.is_hospital)
                sessionStorage.setItem('username', this.loginForm.username)
                this.$store.commit('INIT_ROLES', Object.values(res.data.role))
                this.$router.push({ path: '/' })
              } else {
                this.$message.warning(res.msg)
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          console.log('login failed')
          return false
        }
      })
    },
    changeType() {
      this.textType = this.textType === 'password' ? 'text' : 'password'
    }
  }
}
</script>

<style lang="scss" scoped>
.mt180 {
  margin-top: 60px;
}
.login-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .header {
    height: 72px;
    line-height: 72px;
    color: #fff;
    text-align: center;
    font-size: 24px;
    background-color: #4a5070;
  }
  .flexbox {
    display: flex;
    align-items: center;
  }
  .justify-content-center {
    justify-content: center;
  }

  .left {
    margin-right: 150px;
    img {
      width: 540px;
    }
  }
  .text {
    width: 60%;
    justify-content: space-around;
    font-weight: 600;
    list-style: square;
    color: #7448a0;
  }
  .login-form {
    border-radius: 5px;
    background-clip: padding-box;
    width: 350px;
    padding: 35px 35px 15px 35px;
    box-shadow: 0 0 9px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .btn-eye {
      cursor: pointer;
    }
    .text-danger {
      color: #f56c6c;
    }
    .login-btn {
      margin: 35px 0 10px 0;
      width: 100%;
    }
  }
}
  .copyright {
    width: 100%;padding:20px 0; text-align: center; position:fixed; bottom: 20px;
    color: #999;
    a {
      margin: 0;
      margin-left: 20px;
      vertical-align: top;

      img {
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
      }
    }
    a,a:link, a:active, a:hover {
      color: #999;
    }
  }
</style>
